import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 10,
    color: "#333",
  },

  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 25,
    borderBottomWidth: 1,
    borderBottomColor: "#e5e5e5",
    paddingBottom: 15,
  },

  companyName: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#0f4a35",
  },

  invoiceTitle: {
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: 10,
  },

  section: {
    marginBottom: 18,
  },

  sectionTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 6,
    color: "#0f4a35",
  },

  addressContainer: {
    flexDirection: "row",
    gap: 20,
    marginBottom: 20,
  },
addressText: {
  fontSize: 10,
  lineHeight: 1.2,
  marginBottom: 4,
},
  addressBox: {
    flex: 1,
    borderWidth: 1,
    borderColor: "#e5e5e5",
    padding: 10,
  },

  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#0f4a35",
    color: "#fff",
    padding: 8,
    fontSize: 10,
    fontWeight: "bold",
  },

  tableRow: {
     flexDirection: "row",
  paddingVertical: 10,
  paddingHorizontal: 8,
  borderBottomWidth: 1,
  borderBottomColor: "#eee",
  alignItems: "center",
  },

  product: {
    flex: 3,
  },

  pack: {
    flex: 1,
    textAlign: "center",
  },

  grind: {
    flex: 2,
    textAlign: "center",
  },

  qty: {
    flex: 1,
    textAlign: "center",
  },

  price: {
    flex: 1.5,
    textAlign: "right",
  },

  total: {
    flex: 1.5,
    textAlign: "right",
  },

  summary: {
    marginTop: 20,
    marginLeft: "auto",
    width: 220,
  },

  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },

  grandTotal: {
    borderTopWidth: 1,
    borderTopColor: "#ccc",
    paddingTop: 10,
    marginTop: 10,
    fontSize: 12,
    fontWeight: "bold",
  },

  footer: {
    marginTop: 40,
    borderTopWidth: 1,
    borderTopColor: "#eee",
    paddingTop: 15,
    textAlign: "center",
    color: "#666",
  },
});

export default function InvoicePDF({ order }) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* HEADER */}

        <View style={styles.header}>
          <View>
  <Image
    src="/logo.png"
    style={{
      width: 120,
      height: 60,
      objectFit: "contain",
    }}
  />
</View>

          <View>
            <Text style={styles.invoiceTitle}>
              ORDER INVOICE
            </Text>

            <Text>
              Order ID: {order.orderDisplayId}
            </Text>

            <Text>
              Payment ID: {order.paymentId}
            </Text>

            <Text>
              Date:{" "}
              {new Date(order.createdAt).toLocaleDateString()}
            </Text>
          </View>
        </View>

        {/* CUSTOMER */}

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            CUSTOMER DETAILS
          </Text>

          <Text>
            {order.customerId.firstName}{" "}
            {order.customerId.lastName}
          </Text>

          <Text>{order.customerId.email}</Text>
        </View>

        {/* ADDRESSES */}

        <View style={styles.addressContainer}>
          <View style={styles.addressBox} >
            <Text style={styles.sectionTitle}>
              SHIPPING ADDRESS
            </Text>

            <Text style={styles.addressText}> 
              {order.shippingAddressId.firstName}{" "}
              {order.shippingAddressId.lastName}
            </Text>

            <Text style={styles.addressText}>
              {order.shippingAddressId.streetAdd1}
            </Text>

            <Text style={styles.addressText}>
              {order.shippingAddressId.city},{" "}
              {order.shippingAddressId.state}
            </Text>

            <Text style={styles.addressText}>
              {
                order.shippingAddressId.countryId
                  .countryName
              }
            </Text>

            <Text style={styles.addressText}>
              {order.shippingAddressId.zipCode}
            </Text>

            <Text style={styles.addressText}>
              {order.shippingAddressId.phone}
            </Text>
          </View>

          <View style={styles.addressBox}>
            <Text style={styles.sectionTitle}>
              BILLING ADDRESS
            </Text>

            <Text style={styles.addressText}>
              {order.billingAddressId.firstName}{" "}
              {order.billingAddressId.lastName}
            </Text>

            <Text style={styles.addressText}>
              {order.billingAddressId.streetAdd1}
            </Text>

            <Text style={styles.addressText}>
              {order.billingAddressId.city},{" "}
              {order.billingAddressId.state}
            </Text>

            <Text style={styles.addressText}>
              {
                order.billingAddressId.countryId
                  .countryName
              }
            </Text>

            <Text style={styles.addressText}>
              {order.billingAddressId.zipCode}
            </Text>

            <Text style={styles.addressText}>
              {order.billingAddressId.phone}
            </Text>
          </View>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            ORDER INFORMATION
          </Text>

          <Text style={styles.addressText}>
            Order Status:{" "}
            {order.orderStatusId.orderStatus}
          </Text>

          <Text style={styles.addressText}>
            Payment Status:{" "}
            {order.paymentStatusId.paymentStatus}
          </Text>

          {order.orderTrackingLink && (
            <Text style={styles.addressText}>
              Tracking Link:
              {" "}
              {order.orderTrackingLink}
            </Text>
          )}
        </View>

        <View style={styles.tableHeader}>
          <Text style={styles.product}>
            Product
          </Text>

          <Text style={styles.pack}>
            Pack
          </Text>

          <Text style={styles.grind}>
            Grind
          </Text>

          <Text style={styles.qty}>
            Qty
          </Text>

          <Text style={styles.price}>
            Price
          </Text>

          <Text style={styles.total}>
            Total
          </Text>
        </View>

        {order.items.map((item) => (
          <View
            style={styles.tableRow}
            key={item._id}
          >
            <Text style={styles.product}>
              {item.productId.productTitle}
            </Text>

            <Text style={styles.pack}>
              {
                item.packSizeId?.packSizeName
              }
            </Text>

            <Text style={styles.grind}>
              {item.grindId?.grindName}
            </Text>

            <Text style={styles.qty}>
              {item.bagQty}
            </Text>

            <Text style={styles.price}>
              $
              {Number(
                item.perPackOfferPrice
              ).toFixed(2)}
            </Text>

            <Text style={styles.total}>
              $
              {Number(
                item.finalPrice
              ).toFixed(2)}
            </Text>
          </View>
        ))}

        <View style={styles.summary}>
          <View style={styles.summaryRow}>
            <Text>Subtotal</Text>

            <Text>
              $
              {Number(
                order.subTotal
              ).toFixed(2)}
            </Text>
          </View>

          <View style={styles.summaryRow}>
            <Text>Shipping</Text>

            <Text>
              $
              {Number(
                order.shipping
              ).toFixed(2)}
            </Text>
          </View>

          <View
            style={[
              styles.summaryRow,
              styles.grandTotal,
            ]}
          >
            <Text>Total</Text>

            <Text>
              $
              {Number(order.total).toFixed(2)}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
}